export default function /* @ngInject */ stripeField() {
    return {
        require: ['^stripeForm', 'ngModel'],
        link: function(scope, element, attrs, ctrls) {
            ctrls[0].registerField(attrs.stripeField, ctrls[1]);
        }
    };
}



// WEBPACK FOOTER //
// ./stripe/directives/stripe-field.js